// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"ed05942f","120":"cec9fece","188":"791e7006","231":"1dc24424","331":"d5dde57e","557":"3779698d","674":"90987729","687":"37f6036b","688":"c33e17c7","748":"6374d8d7"}[chunkId] + ".chunk.css";
};